import { AutocompleteItem, Card, CardBody, Button, Input, Select, SelectItem, Autocomplete, Chip, Checkbox } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faCancel, faEllipsisVertical, faEye, faEyeSlash, faList, faPenAlt, faPlusMinus, faPlusSquare, faRemove, faRemoveFormat, faSave, faSquareXmark, faXmark, faXmarkSquare } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, FixHeight, FixMobileHeight, FixScreenHeight, funValidateNoInput, getModValue, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotal, funCheckNumber } from "../../Utility/utility";
import { resetDetail, setDetailParam, setNewEntryMode } from "../../state/authSlice";
import { useModalToast } from "../../components/modalToast/ModalToastContext";

const CreateUser = () => {
    const { compCode, } = useSelector((state) => state.company)
    //const { isNewEntry, detailParams } = useSelector((state) => state.order)
    const { user, detailParam, isNewEntry } = useSelector((state) => state.auth);
    const [isVisible, setIsVisible] = useState(false)
    const [isUpdatePwd, setIsUpdatePwd] = useState(false)
    const {show}=useModalToast()

    const itemRef = useRef(null);
    const navi = useNavigate();
    const toggleVisibility = () => setIsVisible(!isVisible)
    const formField = {
        userId: "userId",
        salePerAcId: "salePerAcId",
        firstName: "firstName",
        lastName: "lastName",
        loginName: "loginName",
        contactNo: "contactNo",
        password: "password",
        confirmPassword: "confirmPassword",
        isActive: "isActive"
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.userId)
            acc[key] = 0
        else if (key == formField.isActive)
            acc[key] = 1
        else
            acc[key] = ""
        return acc
    }, {})



    const { data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.user.entryDetail,
        queryKey: "fetchEntryDetail",
    })

    useEffect(() => {

        if (!isNewEntry && detailParam && Object.keys(detailParam).length > 0) {
            const { LoginName, UserID, Client_Code } = detailParam
            funGetDetail({
                data: {
                    user_id: UserID,
                    client_code: Client_Code
                }
            })
        }
    }, [])


    const [formData, setFormData] = useState(emptyFormField)



    const handleInputChange = (e) => {
        const { name, value } = e.target
        const valid = funValidateNoInput(value)

        // if (valid) {
        if (name == formField.loginName || name == formField.salePerAcId) {
            setFormData((prev) => ({
                ...prev, [name]: value.toUpperCase()
            })
            )
        }
        else
            setFormData({ ...formData, [name]: value })

        //}

    }

    const handleAutoCompleteChange = (value, name) => {

        setFormData({ ...formData, [name]: value, })



    }
    const dispatch = useDispatch();

    const { isPending, isError, mutate: funAddUpdate } = usePost({
        url: apiRoute.user.addUpdate,
        queryKey: "funAddUpdateUser",
        onSuccessTasks: (data) => {

            dispatch(resetDetail)
            navi(linksUrl.user.userMaster)
        }

    })


    const { mutate: checkACID } = usePost({
        url: apiRoute.account.checkacid,
        queryKey: "checkAcid",
        onSuccessTasks: (data) => {
            console.log(data)
            if (data && data.length > 0) {
                setFormData({ ...formData, [formField.salePerAcId]: "" })
                show("Sale Person ID Exists Use Another One")
                // if (!toast.isActive("vldsaleid")) {
                //     toast.error("Sale Person ID Exists Use Another One", {
                //         "position": "top-center",
                //         toastId: "vldsaleid"
                //     })
                // }
            }
        }
    })

    const { mutate: checkLoginID } = usePost({
        url: apiRoute.user.checkLoginId,
        queryKey: "checkLoginid",
        onSuccessTasks: (data) => {
            console.log(data)
            if (data && data.length > 0) {
                setFormData({ ...formData, [formField.loginName]: "" })
                show("Login ID Exists Use Another One")
                // if (!toast.isActive("vldloginid")) {
                //     toast.error("Login ID Exists Use Another One", {
                //         "position": "top-center",
                //         toastId: "vldloginid"
                //     })
                // }
            }
        }
    })

    const handleBlur = (e) => {
        const { name, value } = e.target
        if (value != "") {
            if (name == formField.loginName) {
                checkLoginID({
                    data: {
                        client_code: user.clientCode,
                        login_id: value
                    }
                })
            }
            else {
                checkACID({
                    data: {
                        comp_code: compCode.join(","),
                        ac_id: formData.salePerAcId

                    }
                })
            }
        }
    }
    useEffect(() => {
        if (!isNewEntry && detail && Object.keys(detail).length > 0) {
            setFormData({
                [formField.firstName]: detail[0].FirstName,
                [formField.lastName]: detail[0].LastName,
                [formField.contactNo]: detail[0].Contact_No,
                [formField.isActive]: detail[0].IsActive,
                [formField.userId]: detail[0].UserId
            })


        }
    }, [detail])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isNewEntry || isUpdatePwd) {
            if (formData.confirmPassword.trim() !== formData.password.trim()) {
                show("Confirm Password Should Be Same As Password")
                // toast.error("Confirm Password Should Be Same As Password", {
                //     position: "top-center"
                // })
                return
            }
        }

        funAddUpdate({
            data: {
                client_code: user.clientCode,
                comp_code: compCode.join(","),
                form_data: formData,
                create_uid: user.username,
                rec_status: isNewEntry ? 2 : 1,
                isupdate_pwd: isUpdatePwd
            }
        })

    }


    const handleReset = () => {
        navi(linksUrl.salesOrder.orderMaster)
        //setFormData({ ...formData, [formField.areaId]: "", [formField.partyId]: "", [formField.itemCode]: "", [formField.itemName]: "", [formField.qty]: 0, [formField.mrp]: 0, [formField.amount]: 0 })
        // setRows([])
        // setSelectedRowId("")
    }
    const handleClickPrev = () => {
        navi(linksUrl.user.userMaster)
    }

    if (isError) {
        {
            show("Some thing Went wrong !")
            // if (!toast.isActive("toatError")) {
            //     toast.error("Some thing Went wrong !", {
            //         "position": "top-center",
            //         className: "error-toast",
            //         toastId: "toatError"
            //     })
            // }
        }
    }
    const handleCheckChnage = (value) => {
        setFormData({ ...formData, [formField.isActive]: value == true ? 1 : 0 })
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer pageName={"New User"}
            breadcrumbs={[]}
            prevPage={{
                show: true,
                onClick: handleClickPrev,
            }}
        >

            <Card>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody className=" py-5" style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}>

                        <div className={`border-0 bg-graay-50  my-2 ${isMobile ? "p-2" : "p-5"}  rounded-md border-red-200 border-1 `}>
                            {/* <Chip className="text-white bg-slate-600 "  variant="solid" ><FontAwesomeIcon className="px-5" icon={faArrowCircleRight} ></FontAwesomeIcon> Add Products</Chip> */}
                            {isNewEntry ?
                                <div className={`flex flex-wrap sm:flex-nowrap  items-center flex gap-3`}>
                                    <div className="w-full">
                                        <Input
                                            type="text"
                                            label="login ID"
                                            placeholder=" "
                                            size="md"
                                            labelPlacement="outside"
                                            name={formField.loginName}
                                            value={formData[formField.loginName]}
                                            color="default"
                                            variant="bordered"
                                            isRequired
                                            maxLength={3}
                                            onChange={handleInputChange}
                                            onBlur={handleBlur}
                                            className={`${isMobile ? "" : "max-w-41"}  `}
                                            classNames={{
                                                // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                                label: " font-semibold text-xs",

                                            }}
                                        />
                                        <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Login ID connot be longer than 3 characters</h2>
                                    </div>
                                    <div className="w-full">
                                        <Input
                                            type="text"
                                            label="Sale Person ID"
                                            placeholder=" "
                                            size="md"
                                            labelPlacement="outside"
                                            name={formField.salePerAcId}
                                            value={formData[formField.salePerAcId]}
                                            color="default"
                                            variant="bordered"
                                            isRequired
                                            maxLength={6}
                                            onChange={handleInputChange}
                                            onBlur={handleBlur}
                                            className={`${isMobile ? "w-full" : "max-w-41"} `}
                                            classNames={{
                                                // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                                label: " font-semibold text-xs",

                                            }}
                                        />
                                        <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Sale Person ID connot be longer than 6 characters</h2>
                                    </div>
                                </div> : ""}
                            <div className={`flex flex-wrap sm:flex-nowrap  items-center flex gap-3 mt-3`}>
                                <Input
                                    type="text"
                                    label="First Name"
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name={formField.firstName}
                                    value={formData[formField.firstName]}
                                    color="default"
                                    variant="bordered"
                                    isRequired
                                    onChange={handleInputChange}
                                    className={`${isMobile ? "w-full" : "max-w-41"}  `}
                                    classNames={{
                                        // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                        label: " font-semibold text-xs",

                                    }}
                                />
                                <Input
                                    type="text"
                                    label="Last Name"
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name={formField.lastName}
                                    value={formData[formField.lastName]}
                                    color="default"
                                    variant="bordered"
                                    isRequired
                                    onChange={handleInputChange}
                                    className={`${isMobile ? "" : "max-w-41"}`}
                                    classNames={{
                                        // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                        label: " font-semibold text-xs",

                                    }}
                                />
                            </div>
                            <div className={`flex flex-wrap sm:flex-nowrap  items-center flex gap-3 mt-3`}>
                                <Input
                                    type="text"
                                    label="Contact No"
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name={formField.contactNo}
                                    value={formData[formField.contactNo]}
                                    color="default"
                                    variant="bordered"
                                    isRequired
                                    onChange={handleInputChange}
                                    className={`${isMobile ? "" : "max-w-41"}`}
                                    classNames={{
                                        // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                        label: " font-semibold text-xs",

                                    }}
                                />

                            </div>
                            <div className=" flex justify-end mt-2">
                                {isNewEntry ? "" : <Checkbox size="md"
                                    classNames={{ "label": "text-rose-600 text-sm font-semibold" }}
                                    className="  w-full  bg-rose-50 border-blue-200  border-0" label="gfu" color={"danger"}
                                    isSelected={isUpdatePwd}

                                    onValueChange={setIsUpdatePwd}>

                                    Update Password</Checkbox>
                                }
                            </div>
                            {isNewEntry || (!isNewEntry && isUpdatePwd) ?
                                <div className={`flex flex-wrap sm:flex-nowrap  items-center  flex gap-3`}>

                                    <Input
                                        label="Password"
                                        placeholder=" "
                                        size="md"
                                        labelPlacement="outside"
                                        name={formField.password}
                                        value={formData[formField.password]}
                                        color="default"
                                        variant="bordered"
                                        isRequired
                                        onChange={handleInputChange}
                                        className={`${isMobile ? "w-full" : "max-w-41"} `}
                                        classNames={{
                                            label: " font-semibold text-xs",
                                        }}

                                        onKeyDown={(e) => {
                                            if (e.key === " ") e.preventDefault();
                                        }}
                                        endContent={
                                            <button
                                                className="focus:outline-none"
                                                size="sm"
                                                type="button"
                                                variant="light"
                                                onClick={toggleVisibility}
                                            >
                                                {isVisible ? (
                                                    <FontAwesomeIcon icon={faEyeSlash} />
                                                ) : (
                                                    <FontAwesomeIcon icon={faEye} />
                                                )}
                                            </button>
                                        }
                                        type={isVisible ? "text" : "password"}
                                    />

                                    <Input
                                        label=" Confirm Password"
                                        placeholder=" "
                                        size="md"
                                        labelPlacement="outside"
                                        name={formField.confirmPassword}
                                        value={formData[formField.confirmPassword]}
                                        color="default"
                                        variant="bordered"
                                        isRequired
                                        onChange={handleInputChange}
                                        className={`${isMobile ? "w-full" : "max-w-41"} 4`}
                                        classNames={{
                                            label: " font-semibold text-xs",
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === " ") e.preventDefault();
                                        }}
                                        endContent={
                                            <button
                                                className="focus:outline-none"
                                                size="sm"
                                                type="button"
                                                variant="light"
                                                onClick={toggleVisibility}
                                            >
                                                {isVisible ? (
                                                    <FontAwesomeIcon icon={faEyeSlash} />
                                                ) : (
                                                    <FontAwesomeIcon icon={faEye} />
                                                )}
                                            </button>
                                        }
                                        type={isVisible ? "text" : "password"}
                                    />


                                </div> : ""}
                            <div className="w-full p-2 border-1 bg-green-50 rounded-md my-5">
                                <Checkbox size="md"
                                    classNames={{ "label": "text-green-800 text-md font-semibold" }}
                                    className="  w-full  border-blue-200  border-0" label="gfu" color={"success"}
                                    isSelected={formData.isActive}

                                    onValueChange={handleCheckChnage}>

                                    IS ACTIVE</Checkbox>
                            </div>


                            <div className="flex  justify-center gap-4 align-top items-center mb-2">
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    isLoading={isPending}
                                    className="text-white text-sm"
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="default"
                                    size="sm"
                                    variant="shadow"
                                    isLoading={isPending}
                                    className="bg-slate-600 text-white text-sm"
                                    onPress={handleReset}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancle
                                </Button>
                            </div>
                        </div>


                    </CardBody>
                </form>
            </Card>
        </MainContainer>
    )
}
export default CreateUser